"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCustomerInfoFromJwt = exports.saveCustomerId = exports.getCustomerId = exports.getCheckoutCustomerIdFromStorage = void 0;
const jwt_decode_1 = require("jwt-decode");
const cookies_1 = require("../../../@customer-area/constants/cookies");
const cookies_2 = require("../cookies");
function getCheckoutCustomerIdFromStorage() {
    return cookies_2.cookies.get(cookies_1.CHECKOUT_CUSTOMER_ID_COOKIE_KEY);
}
exports.getCheckoutCustomerIdFromStorage = getCheckoutCustomerIdFromStorage;
function getCustomerId() {
    const customerToken = getCheckoutCustomerIdFromStorage();
    if (String(customerToken))
        return customerToken;
}
exports.getCustomerId = getCustomerId;
const saveCustomerId = (customerId) => {
    let date = new Date();
    date.setTime(date.getTime() + cookies_1.CHECKOUT_CUSTOMER_ID_COOKIE_EXPIRES_AT);
    cookies_2.cookies.set(cookies_1.CHECKOUT_CUSTOMER_ID_COOKIE_KEY, customerId, {
        expires: date,
    });
};
exports.saveCustomerId = saveCustomerId;
const defaultCustomerInfo = {
    givenName: '',
    profileImage: '',
};
const getCustomerInfoFromJwt = () => {
    try {
        const customerJwt = cookies_2.cookies.get(cookies_1.CONSUMER_AREA_LOGGED_USER_COOKIE_KEY);
        if (!customerJwt) {
            return defaultCustomerInfo;
        }
        const customerInfo = (0, jwt_decode_1.jwtDecode)(customerJwt);
        if (!Object.keys(customerInfo).length) {
            return defaultCustomerInfo;
        }
        return {
            givenName: customerInfo.given_name,
            profileImage: customerInfo.picture,
        };
    }
    catch (error) {
        return defaultCustomerInfo;
    }
};
exports.getCustomerInfoFromJwt = getCustomerInfoFromJwt;
